import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const litMediaApi = createApi({
  reducerPath: 'litMediaApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['LitMedia'],
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({

    updateAudio: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append('file', data.audio_file);
        return {
          url: `summaries/${data.book_id}/${data.book_item_id}/${data.id}/${data.language}`,
          method: 'POST',
          body: formData,
          headers: {
            // "Content-type": "multipart/form-data",
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['LitMedia'],
    }),


    deleteSummary: builder.mutation({
      query: (data) => {
        return {
          url: `summaries/${data.id}/${data.language}`,
          method: 'DELETE',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['LitMedia'],
    }),


    // conver media file to hls
    convertMedia: builder.mutation({
      query: (data) => {
        return {
          url: `summaries`,
          method: 'POST',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['LitMedia'],
    }),






  }),
})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  useDeleteSummaryMutation,
  useUpdateAudioMutation,
  useConvertMediaMutation
} = litMediaApi